import { __decorate, __metadata } from "tslib";
import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { ArrayMaxSize, ArrayMinSize, IsArray, IsBoolean, IsInstance, IsNumber, IsOptional, Max, Min, ValidateNested } from 'class-validator';
import { WebMerchantExposeGroup } from '../interface';
import { PatchWebMerchantAppHomeScreenSliderWidgetSlideDto } from './PatchWebMerchantAppHomeScreenSliderWidgetSlideDto';
export class PatchWebMerchantAppHomeScreenSliderWidgetOptionsDto {
}
__decorate([
    ApiPropertyOptional({ type: () => Boolean }),
    Expose({
        groups: [
            WebMerchantExposeGroup.MODEL,
            WebMerchantExposeGroup.READ,
            WebMerchantExposeGroup.CREATE,
            WebMerchantExposeGroup.UPDATE,
            WebMerchantExposeGroup.PATCH,
        ],
    }),
    IsOptional({ always: true }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PatchWebMerchantAppHomeScreenSliderWidgetOptionsDto.prototype, "isEnabled", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean }),
    Expose({
        groups: [
            WebMerchantExposeGroup.MODEL,
            WebMerchantExposeGroup.READ,
            WebMerchantExposeGroup.CREATE,
            WebMerchantExposeGroup.UPDATE,
            WebMerchantExposeGroup.PATCH,
        ],
    }),
    IsOptional({ always: true }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PatchWebMerchantAppHomeScreenSliderWidgetOptionsDto.prototype, "autoplay", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Number }),
    Expose({
        groups: [
            WebMerchantExposeGroup.MODEL,
            WebMerchantExposeGroup.READ,
            WebMerchantExposeGroup.CREATE,
            WebMerchantExposeGroup.UPDATE,
            WebMerchantExposeGroup.PATCH,
        ],
    }),
    IsOptional({ always: true }),
    IsNumber({}, { always: true }),
    Min(100, { always: true }),
    Max(10000, { always: true }),
    __metadata("design:type", Number)
], PatchWebMerchantAppHomeScreenSliderWidgetOptionsDto.prototype, "autoplayInterval", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean }),
    Expose({
        groups: [
            WebMerchantExposeGroup.MODEL,
            WebMerchantExposeGroup.READ,
            WebMerchantExposeGroup.CREATE,
            WebMerchantExposeGroup.UPDATE,
            WebMerchantExposeGroup.PATCH,
        ],
    }),
    IsOptional({ always: true }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PatchWebMerchantAppHomeScreenSliderWidgetOptionsDto.prototype, "isFullscreen", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchWebMerchantAppHomeScreenSliderWidgetSlideDto, isArray: true }),
    Type(() => PatchWebMerchantAppHomeScreenSliderWidgetSlideDto),
    Expose({
        groups: [
            WebMerchantExposeGroup.MODEL,
            WebMerchantExposeGroup.READ,
            WebMerchantExposeGroup.CREATE,
            WebMerchantExposeGroup.UPDATE,
            WebMerchantExposeGroup.PATCH,
        ],
    }),
    IsOptional({ always: true }),
    IsArray({ always: true }),
    IsInstance(PatchWebMerchantAppHomeScreenSliderWidgetSlideDto, { always: true, each: true }),
    ArrayMinSize(0, { always: true }),
    ArrayMaxSize(50, { always: true }),
    ValidateNested({ always: true, each: true }),
    __metadata("design:type", Array)
], PatchWebMerchantAppHomeScreenSliderWidgetOptionsDto.prototype, "slides", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean }),
    Expose({
        groups: [
            WebMerchantExposeGroup.MODEL,
            WebMerchantExposeGroup.READ,
            WebMerchantExposeGroup.CREATE,
            WebMerchantExposeGroup.UPDATE,
            WebMerchantExposeGroup.PATCH,
        ],
    }),
    IsOptional({ always: true }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PatchWebMerchantAppHomeScreenSliderWidgetOptionsDto.prototype, "orderNowWidgetIsInside", void 0);
//# sourceMappingURL=PatchWebMerchantAppHomeScreenSliderWidgetOptionsDto.js.map